'use client'

import { useEffect } from 'react'
import { hasUserAcceptedCookies } from 'app/utils/cookieConsent'

interface AdsBannerProps {
    adsEnabled?: boolean
    publisherId?: string | null
    adSlot?: string | null
}

/**
 * AdsBanner - Full-width banner advertisement component
 * 
 * Displays a Google AdSense banner ad at the top of page content.
 * Only shows if:
 * - ads_enabled is true in config
 * - publisher ID and ad slot are configured
 * - user has accepted cookies
 */
export default function AdsBanner({ adsEnabled = false, publisherId, adSlot }: AdsBannerProps) {
    useEffect(() => {
        if (!adsEnabled || !hasUserAcceptedCookies()) return

        // Initialize AdSense ad after component mounts
        try {
            if (typeof window !== 'undefined') {
                const adsbygoogle = (window as any).adsbygoogle || []
                adsbygoogle.push({})
            }
        } catch (error) {
            console.error('[AdsBanner] Error initializing ad:', error)
        }
    }, [adsEnabled])

    if (!adsEnabled || !publisherId || !adSlot) {
        return null
    }

    return (
        <div className='w-full mb-4 flex justify-center items-center min-h-[100px] bg-gray-100 dark:bg-gray-800'>
            <ins
                className='adsbygoogle'
                style={{ display: 'block', width: '100%', height: '100px' }}
                data-ad-client={publisherId}
                data-ad-slot={adSlot}
                data-ad-format='auto'
                data-full-width-responsive='true'
            />
        </div>
    )
}
